// Note: Global Components
import React from 'react';
import GlobalLoading from '../components/Loading/GlobalLoading';
import GlobalDialog from '../components/Dialog/GlobalDialog';
import ConfirmDialog from '../components/Dialog/ConfirmDialog';
// import NetworkStatus from './NetworkStatus';
// import AppPerformanceStats from '../components/AppPerformanceStats/AppPerformanceStats';

export default function GlobalComponents() {
  return (
    <>
      <GlobalLoading />
      <ConfirmDialog />
      {/*<GlobalDialog />*/}

      {/*<NetworkStatus />*/}
      {/*<AppPerformanceStats />*/}
    </>
  );
}
